import script from "./ErrorView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorView.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorView.vue?vue&type=style&index=0&id=b1adbbca&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1adbbca"]])

export default __exports__